<template>
  <div class="hotel-autocomplete">
    <autocomplete
      :ref="id"
      :id="id"
      aria-label="Hotel"
      placeholder="Hotel | AIRBNB | DESTINO"
      :search="search"
      :get-result-value="getResultValue"
      :state="state"
      :default-value="hotel.value"
      @submit="handleSubmit"
      :disabled="disabled"
    >
      
      <template #result="{ result, props }">
        <li
          v-bind="props"
          class="autocomplete-result wiki-result"
        >
          <div class="wiki-title">
            {{ result.value }}
          </div>
        </li>
      </template>
    </autocomplete>
  </div>
</template>
<script>
  import Autocomplete from '@trevoreyre/autocomplete-vue'
  import '@trevoreyre/autocomplete-vue/dist/style.css'
  // const axios = require('axios');
  export default {
    name: "HotelAutocomplete",
    props: {
      defaultHotel: {
        required: true,
        type: Object
      },
      id: {
        required: true,
        type: String
      },
      disabled:{
        type:Boolean,
        default: false
      },
      state:{
        default: null
      },
      listHotels: {
        type: Array,
        default: null
      }
    },
    components: {
      Autocomplete
    },
    /*data() {
      console.log('this.defaultHotel', this.defaultHotel);
      return {
        hotel: this.defaultHotel,
      }
    },*/
    mounted() {
      // console.log('MIX_APP_URL', process.env.MIX_APP_URL)
    },
    methods: {
      search(input) {
        this.$emit('on-search', {input : input})
        if (this.listHotels) {
          if (input.length < 3) {
            return []
          }
          return this.listHotels.filter(hotel => {
            return hotel.value.toLowerCase()
              .startsWith(input.toLowerCase())
          })
        } else {
          return new Promise(resolve => {
            const url = `${process.env.MIX_APP_URL}/api-feraltar/search-hotels?q=${encodeURI(
              input
            )}`
  
            if (input.length < 3) {
              return resolve([])
            }
            this.$axios.get(url).then(rs => {
              // console.log('data.data', rs.data);
              resolve(rs.data.hotels)
            })
            .catch(error=> {
              console.log('error search hotel', error);
            })
          })
        }
      },
      
      getResultValue(result) {
        return result.value
      },
      
      handleSubmit(result)  {
        this.$emit('update:default-hotel', result)
        this.$emit('on-select-hotel', result)
      },
    },
    computed: {
      hotel() {
        return this.defaultHotel
      }
    },
    watch: {
      defaultHotel(val) {
        this.$emit('update:default-hotel', val)
        this.$refs[this.id].value = val.value
      }
    }
  }
</script>